function sprite(id) {
    return icon_svg(`icons.svg#ic_24_${id}`);
}
function icon_svg(file) {
    return icon('svg', file);
}
function icon_img(file, hideValue) {
    return icon('img', file, hideValue);
}
function icon(type, file, hideValue) {
    return {
        type: type,
        icon: type === 'fontawesome' ? file : `../img/${file}`,
        hideValue,
    };
}
const icons = {
    //Beelong
    elsa_beelong_score_v2: {
        'a_plus': icon_img('beelong/A+.svg', true),
        'a': icon_img('beelong/A.svg', true),
        'a_minus': icon_img('beelong/A-.svg', true),
        'b_plus': icon_img('beelong/B+.svg', true),
        'b': icon_img('beelong/B.svg', true),
        'b_minus': icon_img('beelong/B-.svg', true),
        'c_plus': icon_img('beelong/C+.svg', true),
        'c': icon_img('beelong/C.svg', true),
        'c_minus': icon_img('beelong/C-.svg', true),
        'd_plus': icon_img('beelong/D+.svg', true),
        'd': icon_img('beelong/D.svg', true),
        'd_minus': icon_img('beelong/D-.svg', true),
        'e_plus': icon_img('beelong/E+.svg', true),
        'e': icon_img('beelong/E.svg', true),
        'e_minus': icon_img('beelong/E-.svg', true)
    },
};
export default icons;
